// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var React = require("react");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Client = require("@apollo/client");
var PageHelpers$SmartcutsMacros = require("./PageHelpers.bs.js");

function make(make$1) {
  var match = React.useState(function () {
        return {
                userIdentity: undefined
              };
      });
  var setState = match[1];
  var userIdentity = match[0].userIdentity;
  React.useEffect((function () {
          fetch("/api/identity", Fetch.RequestInit.make(/* Get */0, {
                        Accept: "application/json"
                      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function (res) {
                var match = res.status;
                if (match !== 200) {
                  if (match !== 401) {
                    return res.text().then(Js_exn.raiseError);
                  } else {
                    return Promise.resolve(undefined);
                  }
                } else {
                  return res.json().then(function (json) {
                              Curry._1(setState, (function (_state) {
                                      return {
                                              userIdentity: json
                                            };
                                    }));
                              return Promise.resolve(undefined);
                            });
                }
              });
          
        }), []);
  if (userIdentity === undefined) {
    return Curry._1(make$1, userIdentity);
  }
  var client = PageHelpers$SmartcutsMacros.loadApolloClient(userIdentity.token);
  return React.createElement(Client.ApolloProvider, {
              client: client,
              children: Curry._1(make$1, userIdentity)
            });
}

exports.make = make;
/* react Not a pure module */
